import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableRegression = Loadable({
  loader: () => import('./Regression'),
  loading: Loader
});
